/**
 * Country slug ↔ ISO 3166-1 alpha-2 lookup for SEO-friendly directory URLs.
 * Only includes countries we have venue coverage for. Both directions are
 * supported so /facilities/in/spain and /facilities/in/es both resolve.
 */
const COUNTRIES = [
  { iso: "ES", slug: "spain", name: "Spain" },
  { iso: "PT", slug: "portugal", name: "Portugal" },
  { iso: "FR", slug: "france", name: "France" },
  { iso: "GB", slug: "united-kingdom", name: "United Kingdom", aliases: ["uk", "great-britain"] },
  { iso: "IE", slug: "ireland", name: "Ireland" },
  { iso: "DE", slug: "germany", name: "Germany" },
  { iso: "IT", slug: "italy", name: "Italy" },
  { iso: "NL", slug: "netherlands", name: "Netherlands" },
  { iso: "BE", slug: "belgium", name: "Belgium" },
  { iso: "CH", slug: "switzerland", name: "Switzerland" },
  { iso: "AT", slug: "austria", name: "Austria" },
  { iso: "DK", slug: "denmark", name: "Denmark" },
  { iso: "SE", slug: "sweden", name: "Sweden" },
  { iso: "NO", slug: "norway", name: "Norway" },
  { iso: "FI", slug: "finland", name: "Finland" },
  { iso: "PL", slug: "poland", name: "Poland" },
  { iso: "CZ", slug: "czech-republic", name: "Czech Republic" },
  { iso: "HU", slug: "hungary", name: "Hungary" },
  { iso: "GR", slug: "greece", name: "Greece" },
  { iso: "TR", slug: "turkey", name: "Türkiye" },
  { iso: "US", slug: "united-states", name: "United States", aliases: ["usa", "us"] },
  { iso: "CA", slug: "canada", name: "Canada" },
  { iso: "PR", slug: "puerto-rico", name: "Puerto Rico" },
  { iso: "MX", slug: "mexico", name: "Mexico" },
  { iso: "AR", slug: "argentina", name: "Argentina" },
  { iso: "BR", slug: "brazil", name: "Brazil" },
  { iso: "CO", slug: "colombia", name: "Colombia" },
  { iso: "CL", slug: "chile", name: "Chile" },
  { iso: "PE", slug: "peru", name: "Peru" },
  { iso: "JP", slug: "japan", name: "Japan" },
  { iso: "KR", slug: "south-korea", name: "South Korea", aliases: ["korea"] },
  { iso: "CN", slug: "china", name: "China" },
  { iso: "HK", slug: "hong-kong", name: "Hong Kong" },
  { iso: "SG", slug: "singapore", name: "Singapore" },
  { iso: "TH", slug: "thailand", name: "Thailand" },
  { iso: "MY", slug: "malaysia", name: "Malaysia" },
  { iso: "ID", slug: "indonesia", name: "Indonesia" },
  { iso: "PH", slug: "philippines", name: "Philippines" },
  { iso: "IN", slug: "india", name: "India" },
  { iso: "AE", slug: "uae", name: "United Arab Emirates", aliases: ["united-arab-emirates"] },
  { iso: "QA", slug: "qatar", name: "Qatar" },
  { iso: "SA", slug: "saudi-arabia", name: "Saudi Arabia" },
  { iso: "IL", slug: "israel", name: "Israel" },
  { iso: "ZA", slug: "south-africa", name: "South Africa" },
  { iso: "EG", slug: "egypt", name: "Egypt" },
  { iso: "MA", slug: "morocco", name: "Morocco" },
  { iso: "KE", slug: "kenya", name: "Kenya" },
  { iso: "NG", slug: "nigeria", name: "Nigeria" },
  { iso: "AU", slug: "australia", name: "Australia" },
  { iso: "NZ", slug: "new-zealand", name: "New Zealand" },
];

const BY_SLUG = new Map();
for (const c of COUNTRIES) {
  BY_SLUG.set(c.slug.toLowerCase(), c);
  BY_SLUG.set(c.iso.toLowerCase(), c);
  for (const a of c.aliases || []) BY_SLUG.set(a.toLowerCase(), c);
}

export function resolveCountry(slugOrIso) {
  if (!slugOrIso) return null;
  return BY_SLUG.get(String(slugOrIso).toLowerCase()) || null;
}

export const COUNTRY_LIST = COUNTRIES;

// Curated featured countries shown on the directory homepage Browse section
export const FEATURED_COUNTRIES = [
  "spain", "puerto-rico", "united-states", "united-kingdom", "france",
  "germany", "italy", "portugal", "mexico", "argentina", "brazil",
  "japan", "australia", "canada", "uae", "south-africa",
];
